import axios from "axios";
import { SET_ERROR, LATE_PAYROLL, LATE_PAYROLL_DETAIL } from "../../types"
export const latePayrollAction = (payload) => {
    return async (dispatch) => {
        await axios.post(`api/late-payroll/late-payroll`, payload).then(response => {
            dispatch({
                type: LATE_PAYROLL,
                payload: response.data.data
            });
        }).catch(e => {
            dispatch({
                type: SET_ERROR,
                payload: {
                    e, error: true
                }
            })
        })
    }
};

export const latePayrollDetailAction = (payload) => {
    return async (dispatch) => {
        await axios.post(`api/late-payroll/late-payroll-detail`, payload).then(response => {
            dispatch({
                type: LATE_PAYROLL_DETAIL,
                payload: response.data.data
            });
        }).catch(e => {
            dispatch({
                type: SET_ERROR,
                payload: {
                    e, error: true
                }
            })
        })
    }
};